// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__VVtKb","logoImg":"styles_logo-img__WFuvN","logoName":"styles_logo-name__25fx1"};